<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Comprobantes de Pago"
          directory="Correcciones Pendientes"
          :icon="'grid'"
        />
      </div>
    </div>

    <correction-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :deposit-id="depositId"
      :selected-url="selectedUrl"
      :bank-list="bankList"
      :transaction-type-list="transactionTypeList"
      @close-modal="closeAddEditModal"
    />

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <h5 class="card-title m-0">Beneficiario: Servicio de Acreditación Ecuatoriano – SAE</h5>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button class="btn btn-primary" v-on:click="reloadTables()"> <i data-feather="refresh-ccw" class="pr-2"/> Refrescar</button>

        </div>
      </div>
    </div>
    <br>
    <app-table :id="tableId" :options="options" @action="getListAction" />

  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { CorrectionTableHelpers } from "./CorrectionTableHelpers";

export default {
  extends: CoreLibrary,
  name: "IndexCorrection",
  mixins: [CorrectionTableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      depositId: "",
      tableId: "correction-list",
      rowData: {},
      options: {
        url: `${actions.TREASURY_CORRECTIONS}/pending`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: 'Corregir',
            icon: "eye",
            type: "none",
            component: "correction-modal",
            modalId: "correction-add-edit-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        bankList: [{ id: "", value: 'Seleccione Banco' }],
        transactionTypeList: [{ id: "", value: 'Seleccione Transacción' }]
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    reloadTables(){
      this.$hub.$emit("reload-" + this.tableId);
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#correction-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
        this.rowData = rowData;
        this.depositId = rowData.id;
        window.location = `${actions.TREASURY_CORRECTIONS}/openWindow/${this.rowData.id}`;
        // this.openAddEditModal();
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.TREASURY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#pending-delete").modal("hide");
          this.cancelled();
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    data() {
      this.preloader = true;
      let url = `${actions.TREASURY_CORRECTIONS}/options`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.bankList = [
              { id: "", value: 'Seleccione Banco' },
              ...response.data.bank,
            ];
            this.transactionTypeList = [
              { id: "", value: 'Seleccione Transacción' },
              ...response.data.transactiontype,
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
